// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import { getIdFromObj, getIriFromObj } from 'utils/processors';

const getBusinessOpportunityTypeIri = (value) => {
    const iri = getIriFromObj(value);
    if (iri) {
        return iri;
    }

    const id = getIdFromObj(value);
    if (id !== undefined && id !== null && `${id}`.trim()) {
        return `/workmgmt/businessopportunitytypes/${id}`;
    }

    return value === null ? null : undefined;
};

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    parent: 'parent' in (values || {}) ? values?.parent : null,
    children: Array.isArray(values?.children) ? values.children : []
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    id: undefined,
    root: undefined,
    left: undefined,
    right: undefined,
    level: undefined,
    path: undefined,
    children: undefined,
    parent: 'parent' in (values || {}) ? getBusinessOpportunityTypeIri(values?.parent) : undefined
});
